import React from "react";
import style from "../../Styles/Components/Logo.module.css";
import { CloudfrontBackground } from "../CloudfrontAsset";


const Logo = ({ children = null, imgSrc = null, customStyle = null }) => (
  <div className={style.logoContainer} style={customStyle}>
    <CloudfrontBackground
      className={style.logo}
      imageUrl={imgSrc}
      logContext={{ component: "Logo" }}
    >
      {children}
    </CloudfrontBackground>
  </div>
);

export default Logo;
